import {store} from "@/store";

/**
 * Hàm chạy middleware chain tương tự Nuxt, nhưng hỗ trợ async/await hoàn chỉnh
 */
export async function runMiddlewares(to, from, next, middlewares) {
  const context = { to, from, next, store };

  for (const middleware of middlewares) {
    try {
      // Nếu middleware là async → chờ chạy xong
      const result = await new Promise((resolve, reject) => {
        try {
          // Cho phép middleware gọi next() trực tiếp hoặc return Promise
          const nextProxy = (arg) => resolve(arg);
          const output = middleware(context.to, context.from, nextProxy);
          if (output && typeof output.then === "function") {
            output.then(resolve).catch(reject);
          }
        } catch (err) {
          reject(err);
        }
      });

      // Nếu middleware đã gọi next({ name: ... }) → dừng luôn
      if (result && typeof result === "object" && result.name) {
        return next(result);
      }

      // Nếu middleware trả về false → chặn truy cập
      if (result === false) {
        return next(false);
      }

    } catch (err) {
      console.error(`[Middleware Error]: ${middleware.name || "anonymous"}`, err);
      // Nếu middleware lỗi → điều hướng về Home
      return next({ name: "Home" });
    }
  }

  // ✅ Nếu qua hết middleware → cho phép đi tiếp
  return next();
}
